import {
  ItemMatchingHistoryTypes,
  MatchingHistoryParamsTypes,
} from './types';

import axiosInstance from 'services/common/instance';

const matchingHistoryDataService = async (
  params: MatchingHistoryParamsTypes,
) : Promise<ItemMatchingHistoryTypes[]> => {
  const response = await axiosInstance.get('ttpt-ws-order-matching/list-by-today', { params });

  return response.data.data;
};

export default matchingHistoryDataService;
